export default __webpack_public_path__ + "static/media/valley11.ee79dad3.png";